import axios from "axios";

export function getNotificationRecipients() {
  return axios.get("/partner/api/v1/notification-recipients");
}

export function setToRecipient(data) {
  return axios.put("/partner/api/v1/notification-recipients/to", data);
}

export function addCcRecipient(data) {
  return axios.post("/partner/api/v1/notification-recipients/cc", data);
}

export function deleteNotificationRecipient(uuid) {
  return axios.delete(`/partner/api/v1/notification-recipients/${uuid}`);
}
